/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Form,
    FormFromJSON,
    FormToJSON,
} from '../models/Form';

export interface FormsListRequest {
    ordering?: string;
}

export interface FormsRetrieveRequest {
    id: number;
}

/**
 * 
 */
export class FormsApi extends runtime.BaseAPI {

    /**
     * Creates request options for formsList without sending the request
     */
    async formsListRequestOpts(requestParameters: FormsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/forms/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve form definitions.
     */
    async formsListRaw(requestParameters: FormsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Form>>> {
        const requestOptions = await this.formsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FormFromJSON));
    }

    /**
     * A viewset to retrieve form definitions.
     */
    async formsList(requestParameters: FormsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Form>> {
        const response = await this.formsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for formsRetrieve without sending the request
     */
    async formsRetrieveRequestOpts(requestParameters: FormsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling formsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/forms/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve form definitions.
     */
    async formsRetrieveRaw(requestParameters: FormsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Form>> {
        const requestOptions = await this.formsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve form definitions.
     */
    async formsRetrieve(requestParameters: FormsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Form> {
        const response = await this.formsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
